module.exports = __webpack_public_path__ + "media/svg-new/icon-quest1-02c5847b.svg";